import type { IPlacesPort } from '@onboarding/application/ports';
import type { PlacesPredictionRequestDto, PlacePredictionDto } from '@onboarding/application/dtos';

/**
 * Use case for fetching address autocomplete predictions.
 *
 * @param props.placesPort - IPlacesPort implementation (injected)
 * @returns Use case executor
 */
export const fetchPredictionsUseCase = (props: { placesPort: IPlacesPort }) => {
  const { placesPort } = props;

  const execute = async (dto: PlacesPredictionRequestDto): Promise<PlacePredictionDto[]> => {
    return placesPort.fetchPredictions(dto.input, dto.country);
  };

  return { execute };
};
